export default "__VITE_ASSET___gC1cRAN__"